import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { UtilityService } from './utility.service';

declare var window: any;
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    private canReload: boolean = false;
    constructor(private utilityService: UtilityService, private router: Router) {
        this.canReload = utilityService.canRedirectToLogin;
    }
    canActivate() {
        if (this.canReload && window.location.pathname != '/home' && sessionStorage.getItem('previousUrl') == window.location.pathname) {
            this.canReload = false;
            this.router.navigate(['/home']);
        }
        return true;
    }

    canActivateChild() {
        return true;
    }

}